<template>
	<div class="layout__item u-1/1" :class="extraCssClass">
		<h4 class="c-filter-section__sub-heading mb--">
			{{ title }}
			<info-text :info-text="infoText"></info-text>
		</h4>
		<div class="u-1/1" v-if="allNone">
			<div class="zeta mb-">
				Selecteer:
				<a href="javascript:void(0)" @click="selectAllOptions" class="c-link c-link--cta">alles</a> |
				<a href="javascript:void(0)" class="c-link c-link--cta" @click="selectNone">geen</a>
			</div>
		</div>
		<div class="u-1/1" v-if="selectAll">
			<div class="zeta mb-">
				<a href="javascript:void(0)" @click="selectNone" class="c-link c-link--cta">Selecteer alle opties</a>
				<br />
				<span class="small u-text-color-grey u-line-height--comfy"
					>Indien er niets geselecteerd is, worden alle opties meegenomen</span
				>
			</div>
		</div>
		<div
			class="u-1/1"
			v-for="(v, $index) in filterValues"
			:key="v.Value"
			:class="{ 'ml+': v.Value == 'FixedMin2Year' || v.Value == 'Fixed1Year' }"
			:hidden="limitTo && $index + 1 > limitTo && !showLimited"
		>
			<input
				type="checkbox"
				v-model="v.IsSelected"
				class="c-inputfields__input--checkbox"
				@change="updateValues(v)"
				:disabled="v.IsDisabled"
				:id="v.Value + uid"
				:value="v.Value"
			/>

			<label :for="v.Value + uid" class="c-inputfields__label">{{ v.Text }}</label>
		</div>
		<a
			v-if="limitTo && filterValues.length > limitTo"
			class="c-link c-link--cta"
			@click="showLimited = !showLimited"
		>
			<template v-if="!showLimited">Toon meer</template>
			<template v-else>Toon minder</template>
		</a>
	</div>
</template>

<script>
import InfoText from '@/partials/InfoText';
import BaseInput from '@/partials/BaseInput';
export default {
	extends: BaseInput,
	components: { InfoText },
	props: {
		limitTo: null,
		title: String,
		infoText: String,
		isDurationFilter: {
			type: Boolean,
			default: false,
		},
		allNone: Boolean,
		selectAll: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			uid: parseInt(Math.random() * 15151),
			showLimited: false,
		};
	},
	methods: {
		updateValues(changedObject) {
			if (this.isDurationFilter) {
				if (changedObject.Value === 'Fixed1Year' || changedObject.Value === 'FixedMin2Year') {
					if (changedObject.IsSelected) {
						this.filterValues.forEach((tV) => {
							if (tV.Value === 'Fixed') {
								tV.IsSelected = true;
							}
						});
					}
					if (!changedObject.IsSelected) {
						const oneYearSelected = this.filterValues.find((tV) => {
							return tV.Value === 'Fixed1Year';
						}).IsSelected;
						const twoYearSelected = this.filterValues.find((tV) => {
							return tV.Value === 'FixedMin2Year';
						}).IsSelected;
						if (!oneYearSelected && !twoYearSelected) {
							this.filterValues.forEach((tV) => {
								if (tV.Value === 'Fixed') {
									tV.IsSelected = false;
								}
							});
						}
					}
				}
				if (changedObject.Value === 'Fixed') {
					if (!changedObject.IsSelected) {
						this.filterValues.find((tV) => {
							return tV.Value === 'Fixed1Year';
						}).IsSelected = false;
						this.filterValues.find((tV) => {
							return tV.Value === 'FixedMin2Year';
						}).IsSelected = false;
					}
				}
			}
			let values = this.getSelectedValues();
			this.$emit('valuechange', values);
		},
		selectAllOptions() {
			this.filterValues.forEach((fV) => (fV.IsSelected = true));
			this.updateValues();
		},
		selectNone() {
			this.filterValues.forEach((fV) => (fV.IsSelected = false));
			this.updateValues();
		},
	},
};
</script>

<style></style>
